module.exports = __webpack_public_path__ + "img/quest_icon_0013_boss.80bf0780.png";